import { Dialog, DialogContent } from '@cmp-src/primitives/Dialog';
import { Button } from '@v2/components/ui/button';
import { DeleteCommentModalProps } from './types';

export const DeleteCommentModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading
}: DeleteCommentModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="z-popover max-w-md">
        <div className="p-6">
          <h3 className="mb-4 font-semibold text-gray-900 text-lg">
            Delete Comment
          </h3>
          <p className="mb-6">
            Are you sure you want to delete this comment? This action cannot be
            undone.
          </p>
          <div className="flex space-x-3">
            <Button
              onClick={onConfirm}
              variant="destructive"
              disabled={isLoading}
              className="flex-1"
            >
              {isLoading ? 'Deleting...' : 'Delete'}
            </Button>
            <Button onClick={onClose} variant="outline" className="flex-1">
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
